<div class="layout-vbox" style="align-items: flex-start;">
    <h4>New Underwriting Strategy</h4>
    <wj-flex-grid #gridNewUwStrategy style="width: auto;  min-height: 265px"
                  [allowSorting]="Wijmo.AllowSorting.None"
                  [allowResizing]="Wijmo.AllowResizing.Columns"
                  [headersVisibility]="Wijmo.HeadersVisibility.Column" [selectionMode]="Wijmo.SelectionMode.CellRange"
                  [isReadOnly]="false" [autoGenerateColumns]="false"
                  appIntersectionObserver (intersectionCallback)="onNewUwStrategyGridInitialized(gridNewUwStrategy)"
    >
    </wj-flex-grid>

    <div class="layout-hbox" style="width: 100%; align-items: flex-start">
        <div style="width: 520px">
            <h4 style="margin-top: 10px;">Additional Info</h4>
            <h6>Underwriting Year Summary (excl. 1/1/{{pfData.portfolio.value().uwyear + 1}} renewable)</h6>
            <wj-flex-grid #gridAdditionalInfo style="width: auto;"
                          [allowSorting]="Wijmo.AllowSorting.None"
                          [allowResizing]="Wijmo.AllowResizing.Columns"
                          [headersVisibility]="Wijmo.HeadersVisibility.Column" [selectionMode]="Wijmo.SelectionMode.CellRange"
                          [isReadOnly]="false" [autoGenerateColumns]="false"
                          appIntersectionObserver (intersectionCallback)="onAdditionalInfoGridInitialized(gridAdditionalInfo)"
            >
            </wj-flex-grid>

            <wj-flex-grid #gridAdditionalInfo2 style="width: auto; margin-top: 20px"
                          [allowSorting]="Wijmo.AllowSorting.None"
                          [allowResizing]="Wijmo.AllowResizing.Columns"
                          [headersVisibility]="Wijmo.HeadersVisibility.Column" [selectionMode]="Wijmo.SelectionMode.CellRange"
                          [isReadOnly]="true" [autoGenerateColumns]="false"
                          appIntersectionObserver (intersectionCallback)="onAdditionalInfo2GridInitialized(gridAdditionalInfo2)"
            >
            </wj-flex-grid>

            @if (canSeeRateChangeCalibration()) {
            <div class="layout-vbox" style="gap: 5px; align-items: flex-start">
                <h4 style="margin-top: 10px; margin-bottom: 0">
                    Rate Change Calibration
                    <i class="far {{isRateChangeCalibrationVisible() ? 'fa-minus-circle' : 'fa-plus-circle'}}"
                       (click)="toggleRateChangeVisibility(gridRateChangeCalibration)">
                    </i>
                </h4>
                <div class="animated-height" [class.hidden]="!isRateChangeCalibrationVisible()">
                    <wj-flex-grid #gridRateChangeCalibration style="width: auto;"
                                  [allowSorting]="Wijmo.AllowSorting.None"
                                  [allowResizing]="Wijmo.AllowResizing.Columns"
                                  [headersVisibility]="Wijmo.HeadersVisibility.Column" [selectionMode]="Wijmo.SelectionMode.CellRange"
                                  [isReadOnly]="false" [autoGenerateColumns]="false"
                                  appIntersectionObserver (intersectionCallback)="onRateChangeCalibrationGridInitialized(gridRateChangeCalibration)"
                    >
                    </wj-flex-grid>
                    <fluent-button (click)="applyRateChangeCalibration(gridRateChangeCalibration)" appearance="primary"
                        [disabled]="!canApplyRateChangeAdjustment()">
                        Allocate Rate Change
                    </fluent-button>
                </div>
            </div>
            }
        </div>

        <div style="margin-top: 50px">
            <app-ats-scatter-chart [data]="atsChartData()" [ranges]="atsChartRanges()" [bindingY]="'new_target_rate_change'"
                                   [noDataAlertText]="'No accounts left'"
                                   style="width: 650px; height: 400px"></app-ats-scatter-chart>

            @if (canSeeRateChangeCalibration()) {
                <wj-flex-chart bindingX="name" header="Premium Walk" style="width: 650px; height: 600px">

                    <wj-flex-chart-axis wjProperty="axisY" [axisLine]="true" format="n1,," [min]="0.00" title="Gross Net Premium [mEUR]"

                    >
                    </wj-flex-chart-axis>

                    <wj-flex-chart-axis wjProperty="axisX" [labelAngle]="-60"
                                        [overlappingLabels]="Wijmo.OverlappingLabels.Show" [labelPadding]="10">
                    </wj-flex-chart-axis>


                    <wj-flex-chart-waterfall #wfc name="" binding="value" [styles]="GeneraliWaterfallChartStyle" [connectorLines]="false"
                                             [showIntermediateTotal]="false"
                                             [showTotal]="false" totalLabel="Plan LR" [relativeData]="true">
                    </wj-flex-chart-waterfall>

                    <wj-flex-chart-data-label [position]="Wijmo.LabelPosition.Top" content="{label}" [style]="WfcCategoryText"></wj-flex-chart-data-label>
                </wj-flex-chart>
            }
        </div>
    </div>

</div>
